import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import store, { persistor }  from './store';
import { PersistGate } from "redux-persist/integration/react";
// import CacheBuster from './CacheBuster';
 
const root = ReactDOM.createRoot(document.getElementById('root'));
 
if ('serviceWorker' in navigator) {
  const isProduction = window.location.hostname === 'unextpro.com';
  const swPath = isProduction ? '/service-worker.js' : '/unext/service-worker.js';
  const swScope = isProduction ? '/' : '/unext/';
 
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    const isAlreadyRegistered = registrations.some(
      (r) => r.scope === `${window.location.origin}${swScope}`
    );
 
    if (!isAlreadyRegistered) {
      navigator.serviceWorker.register(swPath, { scope: swScope })
        .then((registration) => {
          console.log('Service Worker registration:', registration);
        })
        .catch((error) => {
          console.log('Service Worker registration failed:', error);
        });
    }
  });
}
 
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename={process.env.PUBLIC_URL}>
                    {/* <CacheBuster /> */}
                    <App />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </React.StrictMode>
);
 
 
 
// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

 

